import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { UtilsService } from "../utils/utils.service";
import { MenuItemPreProcessor } from "../cashier/menu-item-pre-processor-helper.service";
import { WithdrawalService } from "../cashier/withdrawal.service";
import { KeywordsService } from "./keywords.service";
import { CustomerModel } from "src/app/models/customer-model";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { EventsService } from "../event/event.service";

@Injectable({
  providedIn: "root",
})

export class LobbyService {

  waitingGameData = null;
  waitingDialogPage = null;
  waitingDialogPageParams = null;
  liveDealerKeywordName = null;
  restrictedGameData = null;
  public timeOnline: any;
  private isIAB: boolean = false;
  private automationRunning: boolean = false;
  public subPage;
  private optInId = null;
  public currentLoginTime: Date;
  private gamePopoverOpen: boolean = false;
  public gameSessionToken: any;
  public customer: CustomerModel;
  public selectedItem: any;
  public galleryImagePath = this.config.getConfig().CDN_BASEURL + '/assets/social/games/';  //main image path

  constructor(
    private utils: UtilsService,
    private config: ConfigService,
    private withdrawService: WithdrawalService,
    private keywordsService: KeywordsService,
    private userSession:UserSessionService,
    private http: HttpClient,
    private eventsService:EventsService,
    private webservices: WebservicesService,
  ) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );
    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        this.setGalleryImagePath();
      });
    });
  }

  private setGalleryImagePath() {
    this.galleryImagePath = this.config.getConfig().CDN_BASEURL + '/assets/social/games/';
  }

  clearWaitingGameData() {
    this.waitingGameData = null;
  }

  // Setters implementation pending
  isIABApp(): boolean {
    return this.isIAB;
  }

  getCustomerOptInId() {
    return this.optInId;
  }

  public isVerticalEnabled = (verticalCode) => {
    let isIOS = this.utils.isIosApp();
    let productVerticals = {
      casino: true,
      home: true,
    };
    return verticalCode in productVerticals
      ? productVerticals[verticalCode]
      : true;
  };

  setCustomerOptInId(id) {
    this.optInId = id;
  }

  getWaitingGameData() {
    return this.waitingGameData;
  }

  getWaitingDialogPage() {
    return this.waitingDialogPage;
  }

  setWaitingGameData(data) {
    this.waitingGameData = data;
  }

  setWaitingDialogPage(page) {
    this.waitingDialogPage = page;
  }

  setWaitingDialogPageParams(params) {
    this.waitingDialogPageParams = params;
  }

  getWaitingDialogPageParams() {
    return this.waitingDialogPageParams;
  }

  clearWaitingDialogPageParams() {
    this.waitingDialogPageParams = null;
  }

  //Restricted Game Data
  setRestrictedGameData(id) {
    this.restrictedGameData = id;
  }

  getRestrictedGameData() {
    return this.restrictedGameData;
  }

  clearRestrictedGameData() {
    this.restrictedGameData = null;
  }

  clearWaitingDialogPage() {
    this.waitingDialogPage = null;
  }
  setGamePopoverState(state: boolean) {
    this.gamePopoverOpen = state;
  }

  getSidemenuData(menuSelected) {
    const siteMenuFile = this.config.getConfig().SITE_MENU_FILE;
    let menuParsed;

    try {
      menuParsed = JSON.parse(siteMenuFile);
    } catch (e) {
      menuParsed = JSON.parse(
        `{"right": "${siteMenuFile}", "left": "${siteMenuFile}" }`
      );
    }

    let selectedLink = menuSelected === "right" ? menuParsed.right : menuParsed.left;

    let menu_url = this.config.loadCDNAsset(selectedLink);

    return this.http.get(menu_url).toPromise().then((res: any) => {
          const menuOpts = res;

          const menuItemPreProcessor = new MenuItemPreProcessor(
            this.withdrawService,
            this.config
          );

          menuOpts.forEach((menuItem) => {
            menuItemPreProcessor.menuItemPreProcessing(menuItem);
          });

          return menuOpts;
        },
        (err) => console.error(err)
      );
  }

  setCurrentLoginTime(currentLoginTime: Date) {
    this.currentLoginTime = currentLoginTime;
  }

  getCurrentLoginTime() {
    return this.currentLoginTime;
  }

  setGameSessionID(game_token) {
    this.gameSessionToken = game_token;
  }

  getGameSessionID() {
    return this.gameSessionToken;
  }

  clearGameSessionID() {
    this.gameSessionToken = null;
  }

  getLiveDealerUrl(isMobile, liveDealerCategoryLaunch?, vendorName?) {
    let obj: any = {
      customer_id: this.customer?.customerId ?? null,
      session_token: this.userSession?.sessionToken ?? null, 
      vendor: vendorName ? vendorName : "evolution", 
      clientapp: this.config.getClientApp(),
      noredirect : "1",
      is_mobile : isMobile,
    }

    if(!!liveDealerCategoryLaunch) obj.category = liveDealerCategoryLaunch;

    return this.webservices.get('games/launch-lobby', obj)
  } 

  setAutomationRunning(isRunning: boolean) {
    this.automationRunning = isRunning;
  }

  isAutomationRunning(): boolean {
    return this.automationRunning;
  }

  setLiveDealerKeywordName(name) {
    this.liveDealerKeywordName = name;
  }

  getLiveDealerKeywordName(){
    return this.liveDealerKeywordName;
  }

  public setCurrentActiveKeywordItem(data: any) {
    this.selectedItem = data;
  }

  public getCurrentActiveKeywordItem() {
    return this.selectedItem;
  }
}
